import { fetchMetaData } from './fetchMetaData';
import { getWidget } from './getWidget';
export function createSdkMock(_a) {
    var metaSiteId = _a.metaSiteId, appDefId = _a.appDefId, pageId = _a.pageId, compId = _a.compId, instance = _a.instance;
    var request = fetchMetaData({ metaSiteId: metaSiteId, appDefId: appDefId, instance: instance });
    var widgetPromise = request.then(function (_a) {
        var metaData = _a.metaData;
        return getWidget(metaData, pageId, compId);
    });
    return {
        getExternalId: function (onSuccess, onError) {
            widgetPromise.then(function (widget) {
                onSuccess(widget.externalId);
            });
        },
        Styles: {
            getStyleParams: function (callback) {
                widgetPromise.then(function (widget) {
                    var style = widget.style;
                    if (!style) {
                        throw new Error('Widget has no styles');
                    }
                    callback(style);
                });
            },
        },
        Data: {
            Public: {
                get: function (key, options, onSuccess, onFailure) {
                    var newError = function () { return ({
                        error: {
                            message: "key " + key + " not found in " + options.scope + " scope",
                        },
                    }); };
                    var dataSource = options.scope === 'APP'
                        ? request.then(function (_a) {
                            var metaData = _a.metaData;
                            return (metaData.applications &&
                                metaData.applications[appDefId] &&
                                metaData.applications[appDefId].appData) ||
                                {};
                        })
                        : widgetPromise.then(function (widget) { return (widget && widget.data) || {}; });
                    dataSource.then(function (data) {
                        var _a;
                        if (key in data) {
                            onSuccess((_a = {}, _a[key] = data[key], _a));
                        }
                        else {
                            onFailure(newError());
                        }
                    });
                },
            },
        },
    };
}
//# sourceMappingURL=createSdkMock.js.map